<div id="{{ programEnum }}">
  <header>
    <div class="container d-block">
      <div class="d-flex">
        <a class="navbar-brand mt-4 mb--5" routerLink="">
          <img [src]="'/content/images/' + programEnumLower + '/logotipo.png'" alt="logo" class="logo-programa" />
        </a>
      </div>
      <div class="align-items-end d-flex flex-row d-flex flex-row">
        <div class="col col-lg-6 left-banner-column">
          <h2 *ngIf="currentLanguage == 'pt-pt'">{{ generalInformation?.titlePT }}</h2>
          <h2 *ngIf="currentLanguage == 'en'">{{ generalInformation?.titleEN }}</h2>
          <p *ngIf="currentLanguage == 'pt-pt'" class="ban-text">{{ generalInformation?.subtitlePT }}</p>
          <p *ngIf="currentLanguage == 'en'" class="ban-text">{{ generalInformation?.subtitleEN }}</p>
          <a
            (click)="getLink(programEnum)"
            *ngIf="
              programEnum !== enum.PASSE_JOVEM &&
              programEnum !== enum.EQUALITY &&
              programEnum !== enum.WORKCAMP_REGISTRATION &&
              programEnum !== enum.EUROSCOLA &&
              programEnum !== enum.CUIDA_TE &&
              programEnum !== enum.CUIDA_TE2 &&
              programEnum !== enum.OTL &&
              programEnum !== enum.CTI &&
              active == 0
            "
            class="btn-pg btn-inscreve alternate-color"
            >{{ 'homepage.inscreve-te' | translate }}
          </a>

          <a (click)="getLink(programEnum)" *ngIf="programEnum === enum.OTL && active == 0 && selectedModality === ProgramModality.OTL_SHORT" class="btn-pg btn-inscreve alternate-color"
            >{{ 'homepage.inscreve-te' | translate }}
          </a>
          <a (click)="getLink(programEnum)" *ngIf="programEnum === enum.OTL && active == 0 && selectedModality === ProgramModality.OTL_LONG" class="btn-pg btn-inscreve alternate-color"
            >{{ 'homepage.inscreve-te' | translate }}
          </a>
          <a
            (click)="login()"
            *ngIf="
              (programEnum === enum.EQUALITY ||
                programEnum === enum.WORKCAMP_REGISTRATION ||
                programEnum === enum.CUIDA_TE ||
                programEnum === enum.CUIDA_TE2 ||
                (programEnum !== enum.PASSE_JOVEM && active == 1)) &&
              !isAuthenticated()
            "
            class="btn-pg btn-inscreve alternate-color mb-2"
          >
            {{ 'homepage.candidatar' | translate }}
          </a>
          <a href="/content/images/apresentacao_promotores_AN.pdf" target="_blank" *ngIf="programEnum === enum.AGORA_NOS && active === 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a href="/content/images/apresentacao_promotores_GZ.pdf" target="_blank" *ngIf="programEnum === enum.GERACAOZ && active === 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a href="/content/images/apresentacao_promotores_VJNF.pdf" target="_blank" *ngIf="programEnum === enum.FLORESTAS && active === 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a href="/content/images/apresentacao_promotores_NCFP.pdf" target="_blank" *ngIf="programEnum === enum.NAMORAR && active === 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a href="/content/images/apresentacao_promotores_Navegas.pdf" target="_blank" *ngIf="programEnum === enum.NAVEGAS && active === 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a
            href="/content/images/OTL_CD_LD_Entidades_Portal.pdf"
            target="_blank"
            *ngIf="programEnum === enum.OTL && active == 1 && selectedModality === ProgramModality.OTL_SHORT"
            class="btn-pg btn-inscreve alternate-color mt-1 mb-2"
            >Apresentação Promotores
          </a>
          <a href="/content/images/Férias em Movimento_Entidades_Portal.pdf" target="_blank" *ngIf="programEnum === enum.FERIAS && active == 1" class="btn-pg btn-inscreve alternate-color mt-1 mb-2">
            Apresentação Promotores
          </a>
          <a
            href="/content/images/OTL_LD_2025.pdf"
            target="_blank"
            *ngIf="programEnum === enum.OTL && selectedModality === ProgramModality.OTL_LONG"
            class="btn-pg btn-inscreve alternate-color mt-1 mb-2"
            >Apresentação Promotores
          </a>
        </div>
        <div class="col col-lg-6 left-banner-column banner-image">
          <img
            *ngIf="programEnum === enum.CUIDA_TE"
            alt="sexualidade em linha"
            src="/content/images/cuida_te/sexualidade.png"
            style="max-height: 80px; /* float: right; */ background-color: #e9e9e9; padding: 10px; border-radius: 10px; margin-top: -11px; z-index: 2; right: 0; position: absolute; bottom: 30px"
          />
        </div>
      </div>
    </div>
  </header>
  <div *ngIf="modalities.length > 1 && programEnum != enum.CUIDA_TE2" class="container">
    <div class="row tabs-modality">
      <div
        (click)="selectModalityTab($index, modality)"
        *ngFor="let modality of modalities; let $index = index"
        [ngClass]="{
          'col-3': (modalities.length || 0) === 4,
          'col-4': (modalities.length || 0) === 3,
          'col-6': (modalities.length || 0) === 2
        }"
        class="tab-modality col-6"
      >
        <button [ngClass]="{ 'btn-active': isModalityActive($index) }" class="btn-tab">
          {{ 'app.ProgramModality.' + modality | translate }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="youngModalities.length > 1 && programEnum === enum.CUIDA_TE2 && active === 0" class="container">
    <div class="row tabs-modality">
      <div
        (click)="selectModalityTab($index, modality)"
        *ngFor="let modality of youngModalities; let $index = index"
        [ngClass]="{
          'col-3': (youngModalities.length || 0) === 4,
          'col-4': (youngModalities.length || 0) === 3,
          'col-6': (youngModalities.length || 0) === 2
        }"
        class="tab-modality col-6"
      >
        <button [ngClass]="{ 'btn-active': isModalityActive($index) }" class="btn-tab">
          {{ 'app.ProgramModality.' + modality | translate }}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="entitiesModalities.length > 1 && programEnum === enum.CUIDA_TE2 && active === 1" class="container">
    <div class="row tabs-modality">
      <div
        (click)="selectModalityTab($index, modality)"
        *ngFor="let modality of entitiesModalities; let $index = index"
        [ngClass]="{
          'col-3': (entitiesModalities.length || 0) === 4,
          'col-4': (entitiesModalities.length || 0) === 3,
          'col-6': (entitiesModalities.length || 0) === 2
        }"
        class="tab-modality col-6"
      >
        <button [ngClass]="{ 'btn-active': isModalityActive($index) }" class="btn-tab">
          {{ 'app.ProgramModality.' + modality | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <tabset #modalityTabs>
      <tab *ngFor="let modality of modalities"></tab>
    </tabset>
  </div>
  <div
    *ngIf="programEnum != enum.PASSE_JOVEM && programEnum != enum.EQUALITY && programEnum != enum.WORKCAMP_REGISTRATION && programEnum != enum.CUIDA_TE && programEnum != enum.EUROSCOLA"
    class="container"
  >
    <div class="row tabs">
      <div class="tab col-6">
        <button (click)="selectProgramTab(0)" [ngClass]="{ 'btn-active': active == 0, other: active == 1 }" class="btn-tab jovens">
          {{ programEnum + '.jovens' | translate }}
        </button>
      </div>
      <div class="tab col-6">
        <button (click)="selectProgramTab(1)" [ngClass]="{ 'btn-active': active == 1, other: active == 0 }" class="btn-tab entidades">
          {{ programEnum + '.entidades' | translate }}
        </button>
      </div>
    </div>
  </div>
  <tabset #programTabs>
    <tab *ngIf="programEnum != enum.EUROSCOLA && programEnum != enum.EQUALITY && programEnum != enum.WORKCAMP_REGISTRATION && programEnum != enum.CUIDA_TE2 && programEnum != enum.CUIDA_TE">
      <section class="banner2">
        <div class="container">
          <h2 class="about-title">{{ programEnum + '.about' | translate }}</h2>
          <div class="row about">
            <div class="col">
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="generalInformation?.aboutYoungPT" class="text text-an"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="generalInformation?.aboutYoungEN" class="text text-an"></p>
              <img
                *ngIf="programEnum != enum.PASSE_JOVEM && programEnum != enum.SOUDIGITAL"
                [src]="'content/images/' + programEnumLower + '/atividades.png?cache=20190731'"
                alt="atividades"
                class="atividades"
              />
            </div>
          </div>
        </div>
      </section>
      <div class="banner3">
        <div class="container">
          <img *ngIf="programEnum != enum.PASSE_JOVEM && programEnum != enum.SOUDIGITAL" [src]="'content/images/' + programEnumLower + '/back.png?cache=20190731'" alt="back" class="back" />
          <div *ngIf="(currentLanguage == 'pt-pt' && generalInformation?.introTitleYoungPT) || (currentLanguage == 'en' && generalInformation?.introTitleYoungEN)" class="row banner3-first-row p-5">
            <div class="col">
              <h2 *ngIf="currentLanguage == 'pt-pt'" class="title head m-5 text-center">{{ generalInformation?.introTitleYoungPT }}</h2>
              <h2 *ngIf="currentLanguage == 'en'" class="title head m-5 text-center">{{ generalInformation?.introTitleYoungEN }}</h2>
            </div>
          </div>
          <div
            *ngIf="(currentLanguage == 'pt-pt' && generalInformation?.introDescriptionYoungPT) || (currentLanguage == 'en' && generalInformation?.introDescriptionYoungEN)"
            class="row banner3-second-row p-5"
          >
            <div class="col">
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="generalInformation?.introDescriptionYoungPT" class="text text-an text-center"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="generalInformation?.introDescriptionYoungEN" class="text text-an text-center"></p>
            </div>
          </div>
          <div *ngIf="generalInformation?.ageMinimum" class="text-center">
            <span class="age">{{ generalInformation?.ageMinimum }}</span>
            <span class="between-age"> aos</span>
            <span class="age">{{ generalInformation?.ageMaximum }}</span>
          </div>

          <ul class="timeline-list">
            <li *ngFor="let info of youngInformation" class="timeline-row">
              <div *ngIf="currentLanguage == 'pt-pt'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p [innerHTML]="getText(info.descriptionPT)"></p>
                <button class="btn-pg grey-color" *ngIf="info.descriptionPT?.length > 200" (click)="openModal(info.titlePT, info.descriptionPT)">Ver Mais</button>
              </div>
              <div *ngIf="currentLanguage == 'en'" class="timeline_content">
                <h2>{{ info.titleEN }}</h2>
                <p [innerHTML]="getText(info.descriptionEN)"></p>
                <button class="btn-pg grey-color" *ngIf="info.descriptionEN?.length > 200" (click)="openModal(info.titleEN, info.descriptionEN)">Ver Mais</button>
              </div>
            </li>
            <li *ngFor="let info of links" class="timeline-row">
              <div *ngIf="currentLanguage == 'pt-pt'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p>
                  <a [href]="info.urlPT" class="btn-pg principal-color" onclick="" target="_blank">{{ info.titlePT }}</a>
                </p>
              </div>
              <div *ngIf="currentLanguage == 'en'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p>
                  <a [href]="info.urlEN" class="btn-pg principal-color" onclick="" target="_blank">{{ info.titleEN }}</a>
                </p>
              </div>
            </li>
            <li *ngIf="legislation.length > 0" class="timeline-row">
              <div class="timeline_content">
                <h2>{{ 'homepage.legislation' | translate }}</h2>
                <p>{{ 'homepage.legislation-consult' | translate }}</p>
                <ng-container *ngFor="let doc of legislation | orderBy: 'position'">
                  <p>
                    <span *ngIf="currentLanguage == 'pt-pt'">{{ doc.titlePT }}</span>
                    <span *ngIf="currentLanguage == 'en'">{{ doc.titleEN }}</span>
                  </p>
                  <div *ngIf="doc?.documentFile">
                    <a (click)="openFile(doc?.documentFileContentType!, doc?.documentFile, doc.titlePT)" class="btn-pg principal-color" jhiTranslate="entity.action.open">open </a>
                  </div>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </tab>
    <tab *ngIf="programEnum !== enum.PASSE_JOVEM">
      <section class="banner2">
        <div class="container">
          <h2 class="about-title">{{ programEnum + '.about' | translate }}</h2>
          <div class="row about pt-2">
            <div class="col">
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="generalInformation?.aboutInstitutionsPT" class="text text-an"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="generalInformation?.aboutInstitutionsEN" class="text text-an"></p>
              <img
                *ngIf="programEnum !== enum.EUROSCOLA && programEnum !== enum.CUIDA_TE && programEnum !== enum.CUIDA_TE2 && programEnum !== enum.EQUALITY && programEnum !== enum.WORKCAMP_REGISTRATION"
                [src]="'content/images/' + programEnumLower + '/atividades.png?cache=20190731'"
                alt="atividades"
                class="atividades"
              />
            </div>
          </div>
        </div>
      </section>
      <div class="banner3">
        <div class="container">
          <img
            *ngIf="programEnum != enum.EUROSCOLA && programEnum != enum.CUIDA_TE && programEnum != enum.CUIDA_TE2"
            [src]="'content/images/' + programEnumLower + '/back.png?cache=20190731'"
            alt="background"
            class="back"
          />
          <div
            *ngIf="(currentLanguage == 'pt-pt' && generalInformation?.introTitleInstitutionsPT) || (currentLanguage == 'en' && generalInformation?.introTitleInstitutionsEN)"
            class="row banner3-first-row p-5"
          >
            <div class="col">
              <h2 *ngIf="currentLanguage == 'pt-pt'" class="title head m-5 text-center">
                {{ generalInformation?.introTitleInstitutionsPT }}
              </h2>
              <h2 *ngIf="currentLanguage == 'en'" class="title head m-5 text-center">{{ generalInformation?.introTitleInstitutionsEN }}</h2>
            </div>
          </div>
          <div
            *ngIf="(currentLanguage == 'pt-pt' && generalInformation?.introDescriptionInstitutionsPT) || (currentLanguage == 'en' && generalInformation?.introDescriptionInstitutionsEN)"
            class="row banner3-second-row p-5"
          >
            <div class="col">
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="generalInformation?.introDescriptionInstitutionsPT" class="text text-an text-center"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="generalInformation?.introDescriptionInstitutionsEN" class="text text-an text-center"></p>
            </div>
          </div>
          <div *ngIf="generalInformation?.ageMinimumInstitution" class="text-center">
            <span class="age">{{ generalInformation?.ageMinimumInstitution }}</span>
            <span class="between-age"> aos</span>
            <span class="age">{{ generalInformation?.ageMaximumInstitution }}</span>
          </div>

          <ul class="timeline-list">
            <li *ngFor="let info of institutionInformation" class="timeline-row">
              <div *ngIf="currentLanguage == 'pt-pt'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p [innerHTML]="getText(info.descriptionPT)"></p>
                <button class="btn-pg grey-color" *ngIf="info.descriptionPT?.length > 200" (click)="openModal(info.titlePT, info.descriptionPT)">Ver Mais</button>
              </div>
              <div *ngIf="currentLanguage == 'en'" class="timeline_content">
                <h2>{{ info.titleEN }}</h2>
                <p [innerHTML]="getText(info.descriptionEN)"></p>
                <button class="btn-pg grey-color" *ngIf="info.descriptionEN?.length > 200" (click)="openModal(info.titleEN, info.descriptionEN)">Ver Mais</button>
              </div>
            </li>
            <li *ngFor="let info of links" class="timeline-row">
              <div *ngIf="currentLanguage == 'pt-pt'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p>
                  <a [href]="info.urlPT" class="btn-pg principal-color" onclick="" target="_blank">{{ info.titlePT }}</a>
                </p>
              </div>
              <div *ngIf="currentLanguage == 'en'" class="timeline_content">
                <h2>{{ info.titlePT }}</h2>
                <p>
                  <a [href]="info.urlEN" class="btn-pg principal-color" onclick="" target="_blank">{{ info.titleEN }}</a>
                </p>
              </div>
            </li>
            <li *ngIf="legislation.length > 0" class="timeline-row">
              <div class="timeline_content">
                <h2>{{ 'homepage.legislation' | translate }}</h2>
                <p>{{ 'homepage.legislation-consult' | translate }}</p>
                <ng-container *ngFor="let doc of legislation | orderBy: 'position'">
                  <p>
                    <span *ngIf="currentLanguage == 'pt-pt'">{{ doc.titlePT }}</span>
                    <span *ngIf="currentLanguage == 'en'">{{ doc.titleEN }}</span>
                  </p>
                  <div *ngIf="doc?.documentFile">
                    <a (click)="openFile(doc?.documentFileContentType!, doc?.documentFile, doc.titlePT)" class="btn-pg principal-color" jhiTranslate="entity.action.open">open </a>
                  </div>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </tab>
  </tabset>
</div>
